import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { get } from 'ctm-util-functions';
import { ModalContainer } from '../../modal/modal_container';
import { Text } from '../../text/text';

import styles from './discounts.css';
/**
 * This component was developed for energy with the idea of it being generic, but it may be impossible
 * to do a generic discount component with different requirements from each vertical.
 * @deprecated - Move this to energy specific components if there is no other use for it.
 * @returns {Discounts} A discount component
 */
class Discounts extends Component {

    // eslint-disable-next-line react/static-property-placement
    static propTypes = {
        stateProps: PropTypes.shape({
            product: PropTypes.object
        }),
        contentProps: PropTypes.shape({
            label: PropTypes.string,
            maxLength: PropTypes.number,
            labelDataIdBase: PropTypes.string
        }),
        modalProps: PropTypes.shape({
            stateProps: PropTypes.object,
            openComponent: PropTypes.array
        }),
        visualProps: PropTypes.shape({
            variant: PropTypes.string
        }),
        children: PropTypes.array
    };

    /**
     * Appends an ellipses if content is greater than its length
     * @param {String} text The string to cut
     * @returns {String} A cut down string, or the full string.
     */
    trimText = (text) => {
        const { contentProps } = this.props;
        const stringLength = contentProps.maxLength;
        if (stringLength && text.length > stringLength) {
            return `${text.substring(0, stringLength)}... `;
        }
        return text;
    };

    /**
     * Render the Modal Component
     * @returns {Null|Node} Null if the length is shorter than maxlength
     */
    renderModal = () => {
        const { modalProps, contentProps } = this.props;
        const discountText = get(this.props, 'stateProps.product.productMeta.discount.details');
        if (discountText.length < contentProps.maxLength) {
            return null;
        }

        return (
            <ModalContainer {...modalProps}>
                <Text tagName="p" size="medium" innerHTML={discountText} />
            </ModalContainer>
        );
    };

    render = () => {
        const { visualProps, children } = this.props;
        try {
            const discountString = this.trimText(get(this.props, 'stateProps.product.productMeta.discount.details'));
            return (
                <span className={styles.root}>
                    {children}
                    <Text {...visualProps} innerHTML={discountString} />
                    {this.renderModal()}
                </span>
            );
        } catch (e) {
            throw Error('An error occurred creating the discounts modal', e);
        }
    };

}

export { Discounts };
